var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useEffect } from 'react';
import { useLazyQuery, gql } from "@apollo/client";
import { useLocation } from 'react-router-dom';
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
import { react_paths } from "@magento/peregrine/lib/talons/Header/reactRouterPaths";
import { Helmet } from 'react-helmet-async';
var IGNORED_URLS = ['/cart', '/checkout', '/success'];
var HreflangTags = () => {
  var _data$urlResolver;
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var {
    pathname
  } = useLocation();
  var isIgnoredPath = IGNORED_URLS.includes(pathname);
  var [runResolveQuery, {
    data
  }] = useLazyQuery(HREFLANG_RESOLVE_URL);
  var getStaticPath = () => {
    if (pathname === '/') {
      return {
        en: '/',
        fr: '/'
      };
    }
    //startsWith bcause page might have extra /:id
    return react_paths.find(path => pathname.startsWith(path[currentStoreCode]));
  };
  useEffect(() => {
    if (isIgnoredPath) {
      return;
    }
    var staticPathExists = getStaticPath();
    if (!staticPathExists) {
      runResolveQuery({
        //using no-cache because it might be bot
        fetchPolicy: 'no-cache',
        variables: {
          url: pathname,
          storeFrom: currentStoreCode
        },
        context: {
          headers: {
            'store': currentStoreCode
          }
        }
      });
    }
  }, [pathname]);
  var resolverTags = data === null || data === void 0 || (_data$urlResolver = data.urlResolver) === null || _data$urlResolver === void 0 ? void 0 : _data$urlResolver.hreflang;
  var staticPath = getStaticPath();
  var hasData = staticPath || resolverTags;
  var renderCanonicalLink = () => {
    return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
      rel: "canonical",
      href: location.origin + location.pathname
    }));
  };
  var renderAlternateTags = () => {
    var renderStaticTags = () => {
      return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
        rel: "alternate",
        hreflang: "x-default",
        href: "".concat(location.origin, "/en").concat(staticPath.en)
      }), /*#__PURE__*/React.createElement("link", {
        rel: "alternate",
        hreflang: "en",
        href: "".concat(location.origin, "/en").concat(staticPath.en)
      }), /*#__PURE__*/React.createElement("link", {
        rel: "alternate",
        hreflang: "fr",
        href: "".concat(location.origin, "/fr").concat(staticPath.fr)
      }));
    };
    var renderResolvedTags = () => {
      //we have to use this way instead if looping array,
      //because helmet doesn't want any array processing while inserting
      //this is the only proper way
      var resolverTagsObject = {};
      resolverTags.forEach(tag => resolverTagsObject[tag.hreflang] = tag.href);
      return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
        rel: "alternate",
        hreflang: "x-default",
        href: resolverTagsObject["x-default"]
      }), /*#__PURE__*/React.createElement("link", {
        rel: "alternate",
        hreflang: "en",
        href: resolverTagsObject["en"]
      }), /*#__PURE__*/React.createElement("link", {
        rel: "alternate",
        hreflang: "fr",
        href: resolverTagsObject["fr"]
      }));
    };
    if (staticPath) {
      return renderStaticTags();
    } else if (resolverTags && resolverTags.length) {
      return renderResolvedTags();
    } else {
      return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
        rel: "alternate",
        hreflang: currentStoreCode,
        href: location.origin + location.pathname
      }));
    }
  };
  if (isIgnoredPath || !hasData) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderCanonicalLink(), renderAlternateTags());
};
export default HreflangTags;
var HREFLANG_RESOLVE_URL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query hreflangResolveURL($url: String!, $storeFrom: String) {\n        urlResolver(url: $url, storeFrom: $storeFrom) {\n            id\n            type\n            relative_url\n            redirectCode\n            hreflang {\n                hreflang\n                href\n            }\n        }\n    }\n"])));